<template>
  <div class="parallel-detail-container">
    <loading :show="loadingShow"></loading>
    <Header></Header>
    <div
      class="top flex flex-direction align-start justify-center"
      v-if="seminarDetail"
    >
      <img
        v-if="!loadingShow"
        class="right-bg"
        :src="
          isMobile
            ? seminarDetail.i_wapTitleBg_new
              ? seminarDetail.i_wapTitleBg_new
              : require('../../assets/images/cityTravel/detail/banner-bg-wap.png')
            : seminarDetail.i_pcTitleBg_new
            ? seminarDetail.i_pcTitleBg_new
            : require('../../assets/images/cityTravel/detail/banner-bg-pc.png')
        "
        alt=""
      />
      <div class="title" v-html="seminarDetail.name"></div>
      <div
        v-if="seminarDetail.status"
        v-show="seminarDetail.i_signUpId"
        class="sign-up-btn cs"
        @click="didClick_signUp(seminarDetail.i_signUpId)"
      >
        立即报名 >
      </div>
      <div v-else class="end-btn">已结束</div>
    </div>
    <div class="detail-box" v-if="seminarDetail">
      <div class="seminar-container">
        <div class="seminar-box-title">
          <img
            src="../../assets/images/cityTravel/detail/seminar-title-pc.png"
            alt=""
          />
        </div>
        <div class="seminar-box">
          <div class="seminar-info flex align-center">
            <div class="con flex flex-direction" v-html="seminarDetail.intro">
              <!--              <p>各位朋友:</p>-->
              <!--              <p>大家好！</p>-->
              <!--              <p>-->
              <!--                6月15日，<span class="color-red"-->
              <!--                  >“华为伙伴暨开发者大会2022”</span-->
              <!--                >-->
              <!--                将通过线上加线下的方式举行。在这次活动中，我们将围绕伙伴和开发者关心的一些热点话题，比如军团、商业市场、华为云以及计算产业的发展等等，与大家进行深入交流。我们还将推出新的产品和发布新的伙伴政策。-->
              <!--              </p>-->
              <!--              <p>您的参与和您的建议，是我们最大的期待。</p>-->
              <!--              <p>“因聚而生，为你所能”。</p>-->
              <!--              <p>6月15日，不见不散！</p>-->
            </div>
          </div>
          <div class="seminar-map">
            <div class="seminar-map-image-box flex align-end">
              <img
                class="seminar-map-image-pc"
                :src="seminarDetail.i_addressMap"
                alt=""
              />
              <img
                class="seminar-map-image-wap"
                :src="seminarDetail.i_addressMap"
                alt=""
              />
            </div>
            <div class="seminar-map-info">
              <div class="seminar-date">
                <img
                  class="seminar-date-icon"
                  src="../../assets/images/cityTravel/detail/seminar-date-pc.png"
                  alt=""
                />
                会议时间：<span v-if="seminarDetail.i_fuzzyDate">{{
                  seminarDetail.i_fuzzyDate
                }}</span
                ><span v-else>{{ seminarDetail.startAndEndDate }}</span>
              </div>
              <div class="seminar-address">
                <img
                  class="seminar-address-icon"
                  src="../../assets/images/cityTravel/detail/seminar-address-pc.png"
                  alt=""
                />
                会议地址：<span>{{ seminarDetail.hotel }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="agenda-container">
        <div class="agenda-box-title">
          <img
            src="../../assets/images/cityTravel/detail/agenda-title-pc.png"
            alt=""
          />
        </div>
        <div class="agenda-list-box">
          <div
            class="agenda-list"
            v-if="
              seminarDetail.agendaList &&
              seminarDetail.agendaList[0] &&
              seminarDetail.agendaList[0].agendas.length > 0
            "
          >
            <div
              class="agenda"
              :key="index"
              v-for="(agenda, index) in seminarDetail.agendaList[0].agendas"
            >
              <div class="agenda-time-box">
                <div class="agenda-time">
                  <div class="dot"></div>
                  {{ agenda.startTime | timePipe }}-{{
                    agenda.endTime | timePipe
                  }}
                </div>
              </div>
              <div class="agenda-content">
                <div class="title" v-html="agenda.name"></div>
                <div class="child-list">
                  <div class="peoples">
                    <div
                      class="people flex flex-direction"
                      :key="guestIndex"
                      v-for="(guest, guestIndex) in agenda.guests"
                    >
                      <div class="info flex">
                        <div class="name">
                          <span :class="{ between: guest.name.length < 3 }">{{
                            guest.name
                          }}</span>
                        </div>
                        <div class="postiton">{{ guest.duty }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="!this.isMobile"
              class="flex justify-end tips"
              style="margin-top: 20px"
            >
              *以实际议程为准
            </div>
          </div>
          <no-data v-else></no-data>
        </div>
        <div
          v-if="this.isMobile"
          class="flex justify-end tips"
          style="margin-top: 10px; margin-right: 20px"
        >
          *以实际议程为准
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>

<script>
import Header from "../../components/Header";
import Partner from "../../components/parallelSessions/Partner";
import Foot from "../../components/Foot";
import CookTip from "../../components/CookTip";
import Suspension from "../../components/Suspension";
import Agenda from "../../components/parallelSessions/Agenda";
import { seminarAPI } from "@/services/modules/seminar";
import dayjs from "dayjs";
import { mapState } from "vuex";
import { $config } from "../../conf";
import { $api } from "../../services/api";
import moment from "moment";
import Cookie from "js-cookie";
export default {
  name: "cityTravelDetail",
  data() {
    return {
      seminarId: "", //分会场id
      seminarDetail: null,
      agendalist: [], // 页面显示用的列表
      loadingShow: true,
      meeting_name: "", //埋码使用的办事处名称
    };
  },
  filters: {
    handleDate(timestamp) {
      return moment(timestamp * 1000).format("YYYY年MM月DD日");
    },
    timePipe(timestamp) {
      return dayjs(timestamp * 1000).format("HH:mm");
    },
  },
  components: {
    Header,
    Foot,
    noData: () => import("../../components/cityTravel/notData.vue"),
  },
  computed: mapState({
    userInfo: (state) => state.userInfo.info,
    tokenInfo: (state) => state.userInfo.token,
    isLogin: (state) => !!state.userInfo.token,
    AttendanceStatus: (state) => state.userInfo.AttendanceStatus,
    isMobile: (state) => !!state.isMobile,
  }),
  created() {
    if (this.$route.query && this.$route.query.subSeminarId) {
      this.seminarId = this.$route.query.subSeminarId;
      this.getSeminarDeatil(this.$route.query.subSeminarId);
    }
  },
  mounted() {
    if (this.$route.query && this.$route.query.utm_source) {
      Cookie.set("utm_source", this.$route.query.utm_source);
    }
    //埋码使用 办事处名称
    if (this.$route.query && this.$route.query.meeting_name) {
      this.meeting_name = this.$route.query.meeting_name;
    }
  },
  methods: {
    //报名
    didClick_signUp(id) {
      //埋码
      window._hw(
        "send",
        "action",
        "branch_venue_page_channel_register_immediately_click",
        {
          meeting_name: this.meeting_name,
          city: this.seminarDetail.i_office.substring(
            0,
            this.seminarDetail.i_office
              ? this.seminarDetail.i_office.indexOf("\f")
              : this.seminarDetail.i_office.length
          ),
          venue_name: this.seminarDetail.name,
        }
      );
      //&utm_source=xxx
      let openUrl = id;
      const utm_source = Cookie.get("utm_source");
      if (openUrl.includes("?") && typeof utm_source === "string") {
        openUrl = openUrl + "&utm_source=" + utm_source;
      } else if (!openUrl.includes("?") && typeof utm_source === "string") {
        openUrl = openUrl + "?utm_source=" + utm_source;
      }
      window.open(openUrl);
    },
    getSeminarDeatil(seminarId) {
      seminarAPI
        .getSubSeminarDetail(seminarId)
        .then((res) => {
          let seminarDetail = res.content.detail;
          seminarDetail.i_pcTitleBg_new = ""; //域名替换后的 pc顶部背景图
          seminarDetail.i_wapTitleBg_new = ""; //域名替换后的 wap顶部背景图
          seminarDetail.i_addressMap_new = ""; //域名替换后的 地图
          seminarDetail.startAndEndDate = "0"; //开始与结束时间
          if (
            dayjs(seminarDetail.startTime * 1000).format("YYYY/MM/DD") ==
            dayjs(seminarDetail.endTime * 1000).format("YYYY/MM/DD")
          ) {
            //日期相同只取开始时间
            seminarDetail.startAndEndDate = dayjs(
              seminarDetail.startTime * 1000
            ).format("YYYY/MM/DD");
          } else {
            seminarDetail.startAndEndDate =
              dayjs(seminarDetail.startTime * 1000).format("YYYY/MM/DD") +
              "-" +
              dayjs(seminarDetail.endTime * 1000).format("YYYY/MM/DD");
          }
          if (seminarDetail.i_pcTitleBg) {
            seminarDetail.i_pcTitleBg_new = seminarDetail.i_pcTitleBg.replace(
              /^.*\/\/hwyhw.smarket.net.cn/,
              "https://hwyhw-files.smarket.net.cn"
            );
          }
          if (seminarDetail.i_wapTitleBg) {
            seminarDetail.i_wapTitleBg_new = seminarDetail.i_wapTitleBg.replace(
              /^.*\/\/hwyhw.smarket.net.cn/,
              "https://hwyhw-files.smarket.net.cn"
            );
          }
          if (seminarDetail.i_addressMap) {
            seminarDetail.i_addressMap_new = seminarDetail.i_addressMap.replace(
              /^.*\/\/hwyhw.smarket.net.cn/,
              "https://hwyhw-files.smarket.net.cn"
            );
          }
          seminarDetail.status =
            new Date().getTime() > seminarDetail.endTime * 1000 ? false : true;
          this.seminarDetail = seminarDetail;
          this.pipeAgendaList(this.seminarDetail.agendaList);
          this.loadingShow = false;
        })
        .catch((err) => {
          this.loadingShow = false;
        });
    },
    pipeAgendaList(list) {
      let json = {};
      for (let item of list) {
        let day = dayjs(item.startTime * 1000).format("MM.DD");
        item.type = item.i_type[0];
        if (!json[day]) {
          json[day] = {
            key: item.startTime,
            date: day,
            date2: dayjs(item.startTime * 1000).format("YYYY-MM-DD"),
            year: dayjs(item.startTime * 1000).format("YYYY"),
            month: dayjs(item.startTime * 1000).format("M月"),
            day: dayjs(item.startTime * 1000).format("DD"),
            time: dayjs(item.startTime * 1000).format("HH:mm"),
            typeObj: {}, //类型对象
            subs: [], //分会场列表
          };
        }
        let typeObj = json[day].typeObj;
        if (!typeObj[item.type]) {
          typeObj[item.type] = {
            type: item.type,
            list: [item],
          };
          json[day].subs.push(typeObj[item.type]);
        } else {
          typeObj[item.type].list.push(item);
        }
      }
      let listJson = Object.values(json);
      let arr = this.seminarDetail.i_typelist.split(","); //默认类型排序
      //类型排序
      listJson.forEach((item) => {
        item.subs2 = [];
      });
      arr.forEach((tyep) => {
        listJson.forEach((list1) => {
          list1.subs.forEach((list2) => {
            if (tyep == list2.type) {
              list1.subs2.push(list2);
            }
          });
        });
      });
      //日期排序
      listJson.sort((a, b) => {
        return a.key - b.key;
      });
      this.agendalist = listJson;
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (min-width: 992px) {
  @import "./css/detail/pc.scss";
}

@media screen and (max-width: 992px) {
  @import "./css/detail/wap.scss";
}
</style>
